import { render } from "./RegisterSuccessfull.vue?vue&type=template&id=0058a9a1&scoped=true&ts=true"
import script from "./RegisterSuccessfull.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccessfull.vue?vue&type=script&lang=ts"

import "./RegisterSuccessfull.vue?vue&type=style&index=0&id=0058a9a1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0058a9a1"]])

export default __exports__